'use client'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { TIME_RANGE_CUSTOM_VALUE } from '../service-map.const'

import { serviceMapInitialState } from './service-map.slice'
import type { ServiceMapStore } from './service-map.type'

export type { ServiceMapStore, ServiceMapStoreActions, ServiceMapStoreState } from './service-map.type'
export const useServiceMapStore = create<ServiceMapStore>()(
  devtools(
    (set) => ({
      ...serviceMapInitialState,
      setTimeRangeFilter: (value, customRange) =>
        set({
          timeRangeValue: value,
          customRangeApplied: value === TIME_RANGE_CUSTOM_VALUE && customRange ? customRange : null,
        }),
      setRuntimeFilter: (value) => set({ runtimeValue: value }),
      setModuleFilter: (value) => set({ moduleValue: value }),
      setSearchFilter: (value) => set({ searchValue: value }),
      setStatusFilter: (value) => set({ statusValue: value }),
      resetGatewayListFilters: () =>
        set({
          timeRangeValue: serviceMapInitialState.timeRangeValue,
          customRangeApplied: serviceMapInitialState.customRangeApplied,
          runtimeValue: serviceMapInitialState.runtimeValue,
          moduleValue: serviceMapInitialState.moduleValue,
          searchValue: serviceMapInitialState.searchValue,
          statusValue: serviceMapInitialState.statusValue,
        }),
    }),
    {
      name: StoreDevtoolsName.ServiceMap,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
